var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgNotaSelectionSimple = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 60,
    viewBox: "0 0 41 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40.4042V52.0836L0 59.3437V0Z",
    fill: "#FF3700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.5618H12.9447L25.408 31.8529V16.1937L31.7751 15V41.754H26.1531L14.3671 26.2353V41.754H8V15.5618Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNotaSelectionSimple, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/notaSelection-simple.f4d9f865.svg";
export { ForwardRef as ReactComponent };